import { zodResolver } from '@hookform/resolvers/zod'
import { Outlet, createFileRoute } from '@tanstack/react-router'
import { FormProvider, useForm } from 'react-hook-form'
import { useSuspenseQuery } from '@tanstack/react-query'
import { CancelBookingFormFieldSchema } from '@/schemas/booking'
import { getBookingQueryOptions } from '@/queries/query'

export const Route = createFileRoute('/my-booking/$id/cancel')({
  component: RouteComponent,
})

function RouteComponent() {
  const bookingId = Route.useParams({
    select: (s) => s.id,
  })
  const isAuthenticated = Route.useRouteContext({
    select: (s) => s.authContext?.isAuthenticated ?? false,
  })
  const {
    data: {
      data: { booking },
    },
  } = useSuspenseQuery(getBookingQueryOptions(bookingId))
  const form = useForm<CancelBookingFormFieldSchema>({
    mode: 'all',
    resolver: zodResolver(CancelBookingFormFieldSchema),
    defaultValues: {
      id: bookingId,
      booked_transportation_ids: [],
      ...(!isAuthenticated && booking.contact_email
        ? { contact_email: booking.contact_email }
        : {}),
    },
  })
  return (
    <FormProvider {...form}>
      <Outlet />
    </FormProvider>
  )
}
